export default __webpack_public_path__ + "static/media/maroon-gradient-box.af8318c4.svg";